/*
 * @Author: yuanxing(01407381)
 * @Date: 2023-03-07 11:09:52
 * @LastEditors: yuanxing(01407381)
 * @LastEditTime: 2023-05-19 14:59:49
 * @FilePath: \ibu-owt-core-frontend\site\country\sg\index.js
 * @Description:
 */
// import Consign from '../sg/consign/index.vue'
// import Product from '../sg/product/index.vue'
// import Contact from '../sg/contact/index.vue'
// import Dept from '../sg/dept/index.vue'
// import Invoice from '../sg/invoice/index.vue'
// import Careers from './careers/index.vue'
// import Index from './index/index.vue'

// export const pages = {
//   index: Index,
//   consign: Consign,
//   product: Product,
//   contact: Contact,
//   dept: Dept,
//   invoice: Invoice, // 发票申请
//   careers: Careers, // 人才招聘
// }

export const pages = {
  index: () => import('./index/index.vue'), // 首页
  consign: () => import('../sg/consign/index.vue'), // 服务支持 寄件流程指引
  product: () => import('../sg/product/index.vue'), // 物流服务 物流产品详情
  contact: () => import('../sg/contact/index.vue'), // 联系我们
  dept: () => import('../sg/dept/index.vue'), // 服务网点
  invoice: () => import('../sg/invoice/index.vue'), // 发票申请
  careers: () => import('./careers/index.vue'), // 人才招聘
}
